import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";

export function AssistanceSearchCreate() {
    const MainContent = useDynamicComponent("AssistanceSearchCreate");

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <PageTitle title={"Nova Assistência"} allowGoBack={true} />
                </div>

                <div className="pageBody">{MainContent}</div>
            </div>
        </Layout>
    );
}
